import { type IUpdateFeedback, type IUnpublishedFeedback } from '@/app/types/doctorsType'

import style from './FeedbacksWrapper.module.scss'
import { Item } from './Item/Item'

interface IProps {
    unpublishedFeedbacks: IUnpublishedFeedback[]
    isFetchingFeedbacks: boolean
    onRemoveFeedback: (id: string, feedbackId: string, isPublished: boolean) => void
    onPublishFeedback: (dto: IUpdateFeedback) => void
}

export const FeedbacksWrapper = (props: IProps) => {
    const { unpublishedFeedbacks, isFetchingFeedbacks, onRemoveFeedback, onPublishFeedback } = props
    return (
        <div className={style.container}>
            {unpublishedFeedbacks.length < 1 && (
                <div className={style.empty}>
                    <span>Нет отзывов</span>
                </div>
            )}
            {unpublishedFeedbacks.length > 0 &&
                unpublishedFeedbacks.map((feedback) => (
                    <Item
                        key={feedback.id}
                        onRemoveFeedback={onRemoveFeedback}
                        onPublishFeedback={onPublishFeedback}
                        isFetchingFeedbacks={isFetchingFeedbacks}
                        {...feedback}
                    />
                ))}
        </div>
    )
}
